import styled from 'styled-components';

export const TableContainer = styled.div`
    position: relative;
`;

export const SearchWrapper = styled.div`
    margin-left: 60px;
    gap: 12px;
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
`;

export const SelectionRowWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

export const PaginationWrapper = styled.div`
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
`;

